<template>
	<div class="el-menu">
		<el-submenu :index="data.id" v-if="data.children != null">
			<span slot="title" >
				<i class="menuImage"></i>
				<i :class="data.icon ? data.icon : 'el-icon-ali-zidian-'"></i>
				{{ data.label }}
				<!-- <el-badge class="mark msg_card_body_mark" /> -->
			</span>
			<template v-for="obj in data.children">
				<sub-menu :data="obj" :key="obj.id"  v-if="obj.isShow==1"></sub-menu>
			</template>
		</el-submenu>

		<el-menu-item :index="data.id" @click="changeRoute(data)"  v-else >
			<i :class="data.icon ? data.icon : 'el-icon-ali-zidian-'"></i>
			{{ data.label }}
		</el-menu-item>
	</div>
</template>
<script>
import store from '@/store/index.js'; //需要引入store
import subMenu from './sub-menus';
import common from '@/common/common.js';
	
export default {
	name: 'subMenu',
	props: ['data'],
	components: {
		subMenu
	},
	computed: {
		notEnough() {
			return this.$store.state.notEnough;
		}
	},
	methods: {
		changeRoute(data) {
			console.log(data)
			if(data.perUrl==this.$route.path){
				return
			}
			common.initSessionStorage(data)
			common.routerPush(this,data.perUrl);
		}
	},
	mounted: function() {},
	created: function() {
	}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/sub-menus.vue